import control from './control.js'

export default function createControlMixin () {
  return control
}
